// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const menuButton = document.querySelector('.cs-menu-toggle');

    if (!menuButton) {
        return;
    }

    const setOpen = (isOpen) => {
        document.body.classList.toggle('cs-menu-open', isOpen);
        menuButton.setAttribute('aria-expanded', String(isOpen));
    };

    menuButton.addEventListener('click', function () {
        setOpen(!document.body.classList.contains('cs-menu-open'));
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && document.body.classList.contains('cs-menu-open')) {
            setOpen(false);
            menuButton.focus();
        }
    });

    window.matchMedia('(min-width: 64.01rem)').addEventListener('change', function (event) {
        if (event.matches) {
            setOpen(false);
        }
    });
}
